/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Green_Raw_Trout_WadeInputs */

const en_green_raw_trout_wade = /** @type {(inputs: Green_Raw_Trout_WadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created at ${i?.date}`)
};

const de_green_raw_trout_wade = /** @type {(inputs: Green_Raw_Trout_WadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt am ${i?.date} Uhr`)
};

/**
* | output |
* | --- |
* | "Created at {date}" |
*
* @param {Green_Raw_Trout_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_raw_trout_wade = /** @type {((inputs: Green_Raw_Trout_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Raw_Trout_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_raw_trout_wade(inputs)
	return de_green_raw_trout_wade(inputs)
});